import React from 'react';

function SecondaryButton(props) {
  const defaultClass = "whitespace-no-wrap text-cruise_darkblue cursor-pointer ";
  const selectedClass = defaultClass + " font-semibold border-b-2 border-cruise_orange"
  return (
    <div 
      onClick={props.onClick}
      className={props.selected ? selectedClass : defaultClass}>
      {props.buttonText}
    </div>
  );
}

export default SecondaryButton;